import React from 'react';
import { useMediaQuery } from '@/hooks/use-media-query';
import NavSidebar from './NavSidebar';
import NavBottomBar from './NavBottomBar';
import { desktopNavItems, mobileNavItems } from './config';
import { NavigationProps } from './types';

interface ResponsiveNavigationProps {
  onNavigate?: (href: string) => void;
}

/**
 * Responsive Navigation component that renders either the sidebar (desktop) 
 * or bottom bar (mobile) based on screen size
 */
export const Navigation: React.FC<ResponsiveNavigationProps> = ({ 
  onNavigate 
}) => {
  // Use media query to determine which navigation to show
  const isDesktop = useMediaQuery('(min-width: 768px)');
  
  return isDesktop ? (
    <NavSidebar
      items={desktopNavItems}
      onNavigate={onNavigate}
    />
  ) : (
    <NavBottomBar
      items={mobileNavItems}
      onNavigate={onNavigate}
    />
  );
};

export { NavSidebar, NavBottomBar };
